import Firebase from 'firebase/app'

const changePassword = ({ password }) => {  
  return Firebase.auth()
    .currentUser
    .updatePassword(password)
}

export default changePassword
